import React from 'react';
import { X } from 'lucide-react';
import { PRIVACY_INTRO, PRIVACY_LAST_UPDATED, PRIVACY_SECTIONS, PRIVACY_CONTACT_LINES } from '../../constants/privacyPolicy';

const PolicySection = ({ section }) => (
  <div className={section.highlight ? 'bg-gold-100 border-2 border-gold-400 rounded-xl p-4' : undefined}>
    <h4 className="font-bold text-[#143160] mb-2">{section.title}</h4>
    {section.lead && <p className={section.highlight ? 'font-semibold text-gray-800' : undefined}>{section.lead}</p>}
    {section.bullets && (
      <ul className="list-disc ml-6 mt-2 space-y-1">
        {section.bullets.map((b) => <li key={b}>{b}</li>)}
      </ul>
    )}
    {section.after && <p className="mt-2">{section.after}</p>}
  </div>
);

const PolicyBody = () => (
  <div className="p-6 overflow-y-auto max-h-[70vh] space-y-6 text-gray-700 text-sm leading-relaxed">
    <div>
      <h3 className="text-lg font-bold text-[#143160] mb-2">Jess Sells East Coast - Privacy Policy</h3>
      <p className="text-gray-500 text-xs mb-4">Last Updated: {PRIVACY_LAST_UPDATED}</p>
      <p>{PRIVACY_INTRO}</p>
    </div>
    {PRIVACY_SECTIONS.map((s) => <PolicySection key={s.title} section={s} />)}
    <div>
      <h4 className="font-bold text-[#143160] mb-2">Contact Us</h4>
      <p>If you have any questions about this Privacy Policy or our data practices, please contact us:</p>
      <div className="mt-2 bg-sand-100 rounded-lg p-4">
        {PRIVACY_CONTACT_LINES.map((line, i) => <p key={line} className={i === 0 ? 'font-semibold' : undefined}>{line}</p>)}
      </div>
    </div>
    <div className="pt-4 border-t border-gray-200">
      <p className="text-xs text-gray-500">This Privacy Policy may be updated from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.</p>
    </div>
  </div>
);

export const PrivacyPolicyModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="privacy-policy-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-sand-50 rounded-3xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
        <div className="bg-gradient-to-r from-[#143160] to-[#1E4A86] p-6 flex items-center justify-between">
          <h2 className="text-2xl font-serif font-bold text-white">Privacy Policy</h2>
          <button onClick={onClose} data-testid="privacy-policy-close" className="text-white/80 hover:text-white transition-colors"><X className="w-6 h-6" /></button>
        </div>
        <PolicyBody />
        <div className="p-4 bg-sand-100 border-t">
          <button onClick={onClose} className="w-full bg-[#143160] hover:bg-[#1E4A86] text-white py-3 rounded-xl font-bold transition-colors">I Understand</button>
        </div>
      </div>
    </div>
  );
};
